import React, { useImperativeHandle, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography } from '@material-ui/core';
import Controls from './Controls';

interface ConfirmModalPros {
    message: string;
    title: string;
    onConfirmClick: () => void;
    onCanceloClick?: () => void;
}

export interface ConfirmModalHandle {
    handleOpen: (e?: any) => void;
}

const ConfirmModal: React.ForwardRefRenderFunction<ConfirmModalHandle, ConfirmModalPros> = (props, ref) => {

    const { message, title, onConfirmClick, onCanceloClick } = props;

    const [open, setOpen] = useState(false);

    useImperativeHandle(ref, () => {
        return {
            handleOpen
        }
    })

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        if (onCanceloClick) {
            onCanceloClick();
        }
    };

    const handleConfirm = () => {
        onConfirmClick();
        setOpen(false);
    };

    return (
        <div>
            <Dialog
                open={open}
                maxWidth='md'
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title"  >
                    <Typography variant="h6" component={'span'}  align="center">{title}</Typography>
                </DialogTitle>
                <DialogContent>
                    <React.Fragment>
                        <Typography variant="body2" gutterBottom>
                            {message}
                        </Typography>
                    </React.Fragment>
                </DialogContent>
                <DialogActions>
                    <Controls.Button text="Cancelar" type="BlankNoBorder" onClick={handleClose} />
                    <Controls.Button text="Confirmar" type="ErrorNoBorder" onClick={handleConfirm} />
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default React.forwardRef(ConfirmModal)